import LoadingPage from 'components/blocks/LoadingPage';
import Loadable from 'react-loadable';
import { addComponentsToRoutes } from 'services/common';
import PageNotFound from 'containers/PageNotFound';
import routes from './routesOnNav';

const Home = Loadable({
  loader: () => import('containers/Home'),
  loading: LoadingPage,
});

const Mail = Loadable({
  loader: () => import('containers/Mail'),
  loading: LoadingPage,
});

const AutomatedCampaignGeneration = Loadable({
  loader: () => import('containers/AutomatedCampaignGeneration'),
  loading: LoadingPage,
});

const Auth = Loadable({
  loader: () => import('containers/Auth'),
  loading: LoadingPage,
});

const EmailPerformance = Loadable({
  loader: () => import('containers/Performance'),
  loading: LoadingPage,
});

const Unsubscribe = Loadable({
  loader: () => import('containers/Unsubscribe'),
  loading: LoadingPage,
});

const PauseEmails = Loadable({
  loader: () => import('containers/PauseEmails'),
  loading: LoadingPage,
});

const UnSubscription = Loadable({
  loader: () => import('containers/UnSubscription'),
  loading: LoadingPage,
});

const Admin = Loadable({
  loader: () => import('containers/Admin'),
  loading: LoadingPage,
});

const Recommendations = Loadable({
  loader: () => import('containers/Recommendations'),
  loading: LoadingPage,
});

const components = {
  '/': Home,
  '/mail': Mail,
  '/acg': AutomatedCampaignGeneration,
  '/auth': Auth,
  '/performance': EmailPerformance,
  '/unsubscribe': Unsubscribe,
  '/unsubscription': UnSubscription,
  '/pause': PauseEmails,
  '/404': PageNotFound,
  '/admin': Admin,
  '/recommendations': Recommendations,
};

export default addComponentsToRoutes(routes, components);
